import { render } from "./CoffeeCart.vue?vue&type=template&id=2e570962&scoped=true"
import script from "./CoffeeCart.vue?vue&type=script&lang=js"
export * from "./CoffeeCart.vue?vue&type=script&lang=js"

import "./CoffeeCart.vue?vue&type=style&index=0&id=2e570962&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e570962"]])

export default __exports__